import { useMediaQuery } from '@vueuse/core'

/**
 * Viewport breakpoints, in px. They mirror the legacy resize hook, so the shared components
 * and the legacy shell agree on what "mobile" means while both are on screen.
 *
 * `MOBILE_MAX_WIDTH` is the TS twin of `$bp-tablet` in `src/styles/_breakpoints.scss` — the
 * same decision written twice, because SCSS variables and TS constants cannot see each other.
 * **Change one and change the other**, or a screen that branches in both reflows in two steps.
 */
const MOBILE_MAX_WIDTH = 992
const MOBILE_VIEWPORT_MAX_WIDTH = 480

/**
 * Whether the screen is narrow — for a component that has to *render* differently on a
 * phone, not merely look different. A layout that CSS can express belongs in a media
 * query instead.
 *
 * Reads `matchMedia` directly: nothing in `src/shared` may reach for the legacy resize hook
 * or the app store it writes. Note that `matchMedia` measures the viewport where that hook
 * measures `document.body`, so the two can disagree by a scrollbar's width within a pixel
 * of the breakpoint.
 */
export function useViewport() {
  return {
    /** Phone or narrow tablet — inline controls stop fitting. */
    isMobile: useMediaQuery(`(max-width: ${MOBILE_MAX_WIDTH}px)`),
    /** Narrow phone — page padding is dropped altogether. */
    isMobileViewport: useMediaQuery(
      `(max-width: ${MOBILE_VIEWPORT_MAX_WIDTH}px)`
    )
  }
}
